package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsEn : Strings {
  override val locale: String = "en"

  override val header_menu_home: String = "Home"

  override val header_menu_about: String = "About"

  override val header_menu_download: String = "Download"

  override val header_menu_contact: String = "Contact"

  override val header_toggle_color_mode: String = "Toggle color mode"

  override val hero_title: String = "Amazing poses for unforgettable photos"

  override val hero_description: String =
      "Here you will find the inspiration you need! Whether it's for using on Instagram, sharing with friends or even professionally."

  override val about_title: String = "We help you find the perfect pose for your photo!"

  override val about_description_1: String =
      "There's always a doubt when it comes to shotting a pose for a photo, isn't it?"

  override val about_description_2: String =
      "With ProPoses, you have a huge variety of suggestions for every occasion in the palm of your hand."

  override val download_title: String = "Download the ProPoses app now!"

  override val download_description: String =
      "Click on your store below to be redirected and download the app."

  override val download_google_play: String = "Download on Google Play"

  override val download_app_store: String = "Download on App Store"

  override val contact_title: String = "Need to talk to us?"

  override val contact_description: String =
      "If you have any questions, suggestions or requests, please send us an email to the address "

  override val terms_of_use: String = "Terms of use"

  override val privacy_policy: String = "Privacy policy"

  override val copyright: String = "Copyright © 2024 ProPoses. All rights reserved"

  override val terms_screen_title: String = "Terms of Use"

  override val terms_screen_description: String = """
      |
      |        This Term of Use ("Term") sets forth the terms and conditions under which you ("User") may access and use the ProPoses application ("Application"). By accessing or using the Application, you agree to fully comply with the terms of this document.
      |    
      """.trimMargin()

  override val terms_screen_item_1: String = "1. Definitions"

  override val terms_screen_item_1_1_text: String = """
      |
      |        Application: Refers to the ProPoses mobile application and all its services, functionalities and content.
      |    
      """.trimMargin()

  override val terms_screen_item_1_2_text: String = """
      |
      |        User: Refers to any person who accesses or uses the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_1_3_text: String = """
      |
      |        Content: Refers to any information, data, text, software, photographs, graphics, messages, tags, comments or other material that is published on the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_2: String = "2. Registration and Account"

  override val terms_screen_item_2_1_text: String = """
      |
      |        To create your own pose collections in the App, you need to log in with your Google account. This way, you don't need to create a specific account for our App or a new password.
      |    
      """.trimMargin()

  override val terms_screen_item_3: String = "3. Using the Application"

  override val terms_screen_item_3_1_text: String = """
      |
      |        The Application allows you to search for photo poses, save your favorite poses, and share the Application with others. You agree to use the Application only for lawful purposes and in accordance with these Terms.
      |    
      """.trimMargin()

  override val terms_screen_item_4: String = "4. User Generated Content"

  override val terms_screen_item_4_1_text: String = """
      |
      |        By posting any Content to the Application, you grant the Application a worldwide, non-exclusive, royalty-free, irrevocable, sublicensable license to use, copy, modify, adapt, publish, translate, create derivative works from, distribute, perform, and display such Content in any existing or future media. You represent and warrant that you own all rights to the Content you post and that such Content does not violate any third party rights.
      |    
      """.trimMargin()

  override val terms_screen_item_5: String = "5. Prohibitions"

  override val terms_screen_item_5_1_text: String = """
      |
      |        You cannot:
      |    
      """.trimMargin()

  override val terms_screen_item_5_2_text: String = """
      |
      |        Post any Content that is defamatory, obscene, offensive, illegal, invasive of another's privacy or infringes any third party's intellectual property rights.
      |    
      """.trimMargin()

  override val terms_screen_item_5_3_text: String = """
      |
      |        Interfere or attempt to interfere with the proper functioning of the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_5_4_text: String = """
      |
      |        Use any device, software or routine to interfere or attempt to interfere with the proper functioning of the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_6: String = "6. Intellectual Property"

  override val terms_screen_item_6_1_text: String = """
      |
      |        All rights, title and interest in the Application and all its content are owned by the ProPoses team or its licensors.
      |    
      """.trimMargin()

  override val terms_screen_item_7: String = "7. Disclaimer"

  override val terms_screen_item_7_1_text: String = """
      |
      |        The Application is provided "as is" and "as available". ProPoses does not warrant that the Application will be error-free or that it will operate without interruptions. Under no circumstances will ProPoses be liable for any direct, indirect, incidental, special, consequential or punitive damages arising out of the use of or inability to use the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_8: String = "8. Changes"

  override val terms_screen_item_8_1_text: String = """
      |
      |        ProPoses reserves the right to modify these Terms at any time. Changes will be effective immediately upon posting on the Application.
      |    
      """.trimMargin()

  override val terms_screen_item_9: String = "9. Applicable Law and Jurisdiction"

  override val terms_screen_item_9_1_text: String = """
      |
      |        This Agreement shall be governed by and construed in accordance with the laws of Brazil. Any dispute arising from this Agreement shall be subject to the exclusive jurisdiction of the courts of Brazil.
      |    
      """.trimMargin()

  override val privacy_screen_title: String = "Privacy Policy"

  override val privacy_screen_description: String = """
      |
      |        Your privacy is important to us. It is ProPoses' policy to respect your privacy regarding any information we may collect from you across our application.
      |    
      """.trimMargin()

  override val privacy_screen_item_1: String = "1. General information"

  override val privacy_screen_item_1_1_text: String = """
      |
      |        This privacy policy will inform you of how the personal data of people who access the ProPoses app is processed, thus informing you in a transparent manner what the data is, what the purpose of the collection is and how users can control or delete their information.
      |    
      """.trimMargin()

  override val privacy_screen_item_1_2_text: String = """
      |
      |        This text was created in accordance with the Personal Data Protection Law (Law /18), the Internet Civil Rights Framework (Law 12,965/14) and also EU Regulation No. 2016/6790. It is worth noting that this text may be subject to changes due to possible regulatory updates.
      |    
      """.trimMargin()

  override val privacy_screen_item_1_3_text: String = """
      |
      |        We inform you that any and all personal information collected by our app will be used to improve your experience when using it, thus aiming to make it more advantageous and assertive.Informamos que toda e qualquer informação pessoal coletada por nosso app será utilizada para melhorar a sua experiência ao usar o mesmo, visando desta maneira que se torne mais vantajosa e assertiva.
      |    
      """.trimMargin()

  override val privacy_screen_item_2: String = "2. Data collection"

  override val privacy_screen_item_2_1_text: String = """
      |
      |        Personal data is collected when a person logs into the application and based on this, their name and email are collected.
      |    
      """.trimMargin()

  override val privacy_screen_item_2_2_text: String = """
      |
      |        Login to the application is done through the person's Google account, in order to provide more security and avoid the need to create an account/password in our application.
      |    
      """.trimMargin()

  override val privacy_screen_item_2_3_text: String = """
      |
      |        The login is only required for people who wish to create their own pose collections, as this way our system will be able to associate only the items chosen by each person.
      |    
      """.trimMargin()

  override val privacy_screen_item_3: String = "3. Acceptance"

  override val privacy_screen_item_3_1_text: String = """
      |
      |        From the moment the ProPoses application is used, it is assumed that the user has accepted the privacy policy. Therefore, we reserve the right to modify this policy without prior notice. For this reason, we recommend that users regularly consult our policy, so that they are always up to date with possible changes.
      |    
      """.trimMargin()

  override val privacy_screen_item_4: String = "4. Changes to the Privacy Policy"

  override val privacy_screen_item_4_1_text: String = """
      |
      |        This privacy policy was last updated on 10/19/2024 and may be modified at any time without prior notice.
      |    
      """.trimMargin()

  override val privacy_screen_item_5: String = "5. Contato"

  override val privacy_screen_item_5_1_text: String = """
      |
      |        If you have any questions about this Privacy Policy or wish to change/delete your data, please contact us via email at proposes@logicalside.com.br.
      |    
      """.trimMargin()
}
